export default {
  maxValuesPerFacet: 500,
  sortFacetValuesBy: "alpha",
  hitsPerPage: 1000,
  attributesToRetrieve: [
    "objectID",
    "name",
    "custom_url",
    "image",
    "vanillin_free",
    "phthalate_free",
    "shippable_by_air",
    "diffuser_base_compatible",
    "min_price",
    "max_price",
    "soy_performance",
    "best_for_soy_wax",
    "rating",
    "soap_safe",
    "lotion_safe",
    "no_acceleration",
    "no_discoloration",
    "clean_scent",
  ],
  facets: [
    "prop_65_free",
    "diffuser_base_compatible",
    "shippable_by_air",
    "lotion_safe",
    "phthalate_free",
    "searchable_categories",
    "searchable_notes",
    "searchable_seasons",
    "soap_safe",
    "vanillin_free",
    "best_for_soy_wax",
    "no_acceleration",
    "no_discoloration",
    "clean_scent",
  ]
};
